import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import UniverseError from '../components/UniverseError';
import { onServerDown } from '../services/api';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }) => {
  const [isServerDown, setIsServerDown] = useState(false);

  // Subscribe to server down events from api.js
  useEffect(() => {
    const unsubscribe = onServerDown(() => {
      setIsServerDown(true);
    });
    return unsubscribe;
  }, []);

  // Manual trigger to show the error page
  const triggerServerDown = useCallback(() => {
    setIsServerDown(true);
  }, []);

  // Retry handler - resets state and reloads
  const handleRetry = useCallback(() => {
    setIsServerDown(false);
    window.location.reload();
  }, []);

  // If server is down, show the Einstein error page
  if (isServerDown) {
    return <UniverseError onRetry={handleRetry} />;
  }

  return (
    <ErrorContext.Provider
      value={{
        isServerDown,
        triggerServerDown,
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export default ErrorContext;
